import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { RemoveButton } from "../Buttons/RemoveButton";

import img_icon_attachment_icon from "@/Globals/_images/icons/attachment_icon.png";

interface AttachedDocumentItem {
    Model: { openInNewWindow: () => void };
    itemId: number;
}

interface IAttachedDocumentListProps<T extends AttachedDocumentItem> {
    selectedAttachments: T[];
    removeAttachmentFromList?: (id: number, file?: T) => void;
    resolveDescription: (attachment: T) => any;
    showPaperClipIcon?: boolean;
    dataCy?: string;
}

export function AttachedDocumentList<T extends AttachedDocumentItem>(props: IAttachedDocumentListProps<T>): JSX.Element {
    const { getText } = useTranslation();
    return (
        <>
            {props.selectedAttachments.map(p => (
                <div key={p.itemId} className="flex-container flex-start margin-sm-bottom" data-cy={props.dataCy}>
                    <a onClick={() => p.Model.openInNewWindow()} target="_blank">
                        {props.showPaperClipIcon && (
                            <img src={img_icon_attachment_icon} alt={getText("AttachADocumentLabel")} className="hover paperClip-rotation" />
                        )}
                        {props.resolveDescription(p)}
                    </a>
                    {props.removeAttachmentFromList && (
                        <RemoveButton
                            className="margin-sm-left"
                            onRemove={() => props.removeAttachmentFromList(p.itemId, p)}
                        />
                    )}
                </div>
            ))}
        </>
    );
}
